import { render, staticRenderFns } from "./RightsExchangeItem.vue?vue&type=template&id=67fdc0a0&scoped=true"
import script from "./RightsExchangeItem.vue?vue&type=script&lang=js"
export * from "./RightsExchangeItem.vue?vue&type=script&lang=js"
import style0 from "./RightsExchangeItem.vue?vue&type=style&index=0&id=67fdc0a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fdc0a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fdc0a0')) {
      api.createRecord('67fdc0a0', component.options)
    } else {
      api.reload('67fdc0a0', component.options)
    }
    module.hot.accept("./RightsExchangeItem.vue?vue&type=template&id=67fdc0a0&scoped=true", function () {
      api.rerender('67fdc0a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/RightsExchangeItem.vue"
export default component.exports